import React from 'react';
export function SolutionSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-174">
      <div className="max-w-4xl mx-auto text-center" data-id="element-175">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 border border-[#FF6B00]/50 text-[#FF6B00] font-bold text-sm px-5 py-2 rounded-full mb-8 tracking-wide" data-id="element-176">
          🏆 Sistema N°1 para docentes de Inglés en Argentina
        </div>

        <h2 className="text-4xl sm:text-5xl font-black text-white mb-4" data-id="element-177">
          🌟 PROFEPACK
        </h2>
        <h3 className="text-2xl sm:text-3xl font-bold text-[#FF6B00] mb-6" data-id="element-178">
          MEGAPACK INGLÉS LISTO
        </h3>
        <p className="text-white text-lg max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-179">
          <strong data-id="element-180">12 tomos organizados por grado y año.</strong> 720 páginas de
          contenido completo. Solucionario incluido en cada tomo. 6 bonos
          estratégicos. Todo listo para usar desde hoy.
        </p>

        {/* Mockup visual */}
        <div className="relative mx-auto mb-10 max-w-2xl" data-id="element-181">
          <div className="grid grid-cols-6 gap-2 justify-center" data-id="element-182">
            {['#1565C0', '#2E7D32', '#E65100', '#6A1B9A', '#37474F', '#BF360C'].map((color, i) => <div key={i} className="aspect-[3/4] rounded-lg shadow-2xl flex items-end justify-center pb-2" style={{
            backgroundColor: color,
            border: '2px solid #FF6B00'
          }} data-id="element-183">
                <span className="text-white text-xs font-bold" style={{
              textShadow: '0 1px 3px rgba(0,0,0,0.8)'
            }} data-id="element-184">
                  {i + 1}°
                </span>
              </div>)}
          </div>
          <div className="grid grid-cols-6 gap-2 justify-center mt-2" data-id="element-185">
            {['#1A237E', '#1B5E20', '#BF360C', '#4A148C', '#263238', '#3E2723'].map((color, i) => <div key={i} className="aspect-[3/4] rounded-lg shadow-2xl flex items-end justify-center pb-2" style={{
            backgroundColor: color,
            border: '2px solid #FF6B00'
          }} data-id="element-186">
                <span className="text-white text-xs font-bold" style={{
              textShadow: '0 1px 3px rgba(0,0,0,0.8)'
            }} data-id="element-187">
                  {i + 1}°
                </span>
              </div>)}
          </div>
          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-[#FF6B00] text-black font-black text-xs px-4 py-1 rounded-full whitespace-nowrap" data-id="element-188">
            12 TOMOS COMPLETOS
          </div>
        </div>

        {/* Pills */}
        <div className="flex flex-wrap items-center justify-center gap-2 mt-8" data-id="element-189">
          {['Por grado/año', 'Planificación lista', 'Solucionario incluido', 'Evaluaciones + rúbricas'].map(text => <span key={text} className="bg-[#FF6B00]/10 border border-[#FF6B00]/40 text-[#FF6B00] text-xs sm:text-sm font-semibold px-3 py-1.5 rounded-full" data-id="element-190">
              ✅ {text}
            </span>)}
        </div>
      </div>
    </section>;
}